import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=296da75c&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"
import style0 from "./WorldMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports